<template lang="html">
  <div class="coupon-item">
    <div class="coupon-item-price">
      {{couponInfo.value}}<span>元</span>
    </div>
    <div class="coupon-item-desc">
      <h3>职场通识课程{{couponInfo.value}}元代金券</h3>
      <p v-if="endTime">有效期至： {{endTime}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CouponItem',
  props: ['couponInfo',"useEnd"],
  computed: {
    endTime () {
      if (this.useEnd) {
        let endTime = new Date(this.useEnd)
        return  moment(endTime).format('YYYY-MM-DD HH:mm')
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.coupon-item {
  height: rem(156);
  background: url("./images/coupon-bg.png");
  background-size: 100% 100%;
  color: #F48F00;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: rem(16);
  padding: 0 rem(33);
  &-price {
    font-size: rem(72);
    > span {
      font-size: rem(40);
    }
  }
  &-desc {
    line-height: 1.3;
    h3 {
      font-size: rem(26);
    }
    p {
      color: #666666;
      font-size: rem(22);
    }
  }
}
</style>
